import React from 'react';
import { useInView } from '../hooks/useInView';
export function PainSection() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section ref={ref} className="w-full bg-cream py-10 px-6 md:py-14" data-id="element-120">
      <div className={`max-w-2xl mx-auto space-y-12 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-121">
        {/* Subsection 1 */}
        <article className="space-y-4" data-id="element-122">
          <h2 className="font-serif text-3xl text-navy font-bold" data-id="element-123">
            Esto no se siente como "un problema"
          </h2>
          <div className="text-text-dark font-sans text-lg leading-relaxed" data-id="element-124">
            <p className="mb-3" data-id="element-125">Se siente como tu vida normal.</p>
            <ul className="list-none space-y-1 mb-4 pl-4 border-l-2 border-gold/30" data-id="element-126">
              <li data-id="element-127">- La cabeza haciendo lista.</li>
              <li data-id="element-128">- El cuerpo cansado.</li>
              <li data-id="element-129">- El corazón con culpa.</li>
            </ul>
            <p className="mb-3" data-id="element-130">
              Y una idea que se repite con diferentes disfraces:
            </p>

            <div className="space-y-2 my-5 pl-5" data-id="element-131">
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-132">
                "Podrías hacerlo mejor."
              </p>
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-133">
                "Deberías ser más paciente."
              </p>
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-134">
                "Cómo no vas a poder."
              </p>
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-135">
                "Mira a las otras…"
              </p>
            </div>

            <p className="font-medium text-navy" data-id="element-136">
              La Mamá Juez no descansa.
              <br data-id="element-137" />Y cuando tú por fin te sientas… recién empieza a hablar más
              fuerte.
            </p>
          </div>
        </article>

        {/* Subsection 2 */}
        <article className="space-y-4" data-id="element-138">
          <h2 className="font-serif text-3xl text-navy font-bold" data-id="element-139">
            Un patrón exigente que se repite
          </h2>
          <div className="text-text-dark font-sans text-lg leading-relaxed" data-id="element-140">
            <div className="bg-white p-5 rounded-lg shadow-sm border border-gold/10 space-y-2 mb-4" data-id="element-141">
              <p data-id="element-142">
                <span className="font-bold text-navy" data-id="element-143">Si trabajas:</span> "no
                estás."
              </p>
              <p data-id="element-144">
                <span className="font-bold text-navy" data-id="element-145">
                  Si te quedas en casa:
                </span>{' '}
                "no aportas."
              </p>
              <p data-id="element-146">
                <span className="font-bold text-navy" data-id="element-147">Si haces ambas:</span>{' '}
                "igual no alcanza."
              </p>
            </div>
            <p data-id="element-148">
              Ese estándar no está diseñado para que vivas. Está diseñado para
              que te cobres.
            </p>
            <p className="font-medium text-navy text-xl mt-2" data-id="element-149">
              Y cuando una madre se cobra todo… se queda sin aire para
              disfrutar.
            </p>
          </div>
        </article>

        {/* Subsection 3 */}
        <article className="space-y-4" data-id="element-150">
          <h2 className="font-serif text-3xl text-navy font-bold" data-id="element-151">
            No eres tú "siendo débil"
          </h2>
          <div className="text-text-dark font-sans text-lg leading-relaxed" data-id="element-152">
            <p data-id="element-153">
              Tu mente está haciendo algo que aprendió: usar la crítica como
              forma de control.
            </p>
            <p className="mt-2" data-id="element-154">
              Porque si te exiges, crees que: no te equivocas, no fallas, no te
              juzgan, tus hijos "están bien".
            </p>
            <p className="mt-3" data-id="element-155">Pero hay un costo.</p>
            <p data-id="element-156">
              La exigencia constante no te vuelve mejor. Te vuelve dura contigo.
            </p>
            <p className="font-serif text-2xl text-gold-dark mt-3 italic" data-id="element-157">
              Y una mamá dura consigo… se queda sin ternura para su propia vida.
            </p>
          </div>
        </article>
      </div>
    </section>;
}